import { Injectable } from '@angular/core';
import { ConnectionService } from './connection.service';
import {Http, Headers, RequestOptions} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Task } from '../entities/Task';
import { TaskPageModel } from '../entities/PageModel';
import { AppConfig } from '../app.config';
import { TaskFilterModel } from '../entities/filter-models/TaskFilterModel';
import { FilterModel } from '../entities/FilterModel';
import {RequestInterceptor} from "./Interceptors/RequestInterceptor";

@Injectable()
export class TaskService {
  private readonly apiUrl: string;

  private getHeaders(company = null): RequestOptions {
    const headers: Headers = this.connectionService.GetAuthorizationHeader(company);
    return new RequestOptions({ headers });
  }

  constructor(
    private requestInterceptor: RequestInterceptor,
    private http: Http,
    private connectionService: ConnectionService,
    private config: AppConfig) {
    this.apiUrl = config.getConfig('endPointApiUrl');
  }

  getUnassignedTasks(pageIndex): Observable<TaskPageModel> {
    let url: string = this.apiUrl + 'api/Tasks/GetUnassigned/' + pageIndex;

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as TaskPageModel);
  }

  getPlannedTasks(pageIndex): Observable<TaskPageModel> {
    let url: string = this.apiUrl + 'api/Tasks/GetPlanned/' + pageIndex;

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as TaskPageModel);
  }

  getUnassignedTasksForJob(pageIndex, jobNo): Observable<TaskPageModel> {
    let url = this.apiUrl + 'api/Tasks/GetUnassignedForJob/' + pageIndex + '/' + jobNo;

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as TaskPageModel);
  }

  getPlannedTasksForJob(pageIndex, jobNo): Observable<TaskPageModel> {
    let url = this.apiUrl + 'api/Tasks/GetPlannedForJob/' + pageIndex + '/' + jobNo;

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as TaskPageModel);
  }

  getTasks(): Observable<Task[]> {
    let url = this.apiUrl + 'api/Tasks';

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as Task[]);
  }

  getTasksWithFilter(taskFilterModel: TaskFilterModel): Observable<TaskFilterModel>
  {
    let url: string = this.apiUrl + 'api/Tasks/GetTasksWithFilter';
    url += '&Responsible=';
    if (taskFilterModel.ResponsibleInput != null) {
      url += taskFilterModel.ResponsibleInput;
    }

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as TaskFilterModel);
  }

  getFilteredTasks(taskPageModel: TaskPageModel): Observable<TaskPageModel> {
    let url: string = this.apiUrl + 'api/Tasks/GetFilteredTasks/?taskPage=' + taskPageModel.PageIndex;
    url += '&jobNo=';
    if (taskPageModel.JobNo != null) {
      url += taskPageModel.JobNo;
    }
    url += '&taskNo=';
    if (taskPageModel.TaskNo != null) {
      url += taskPageModel.TaskNo;
    }
    url += '&taskType=';
    if (taskPageModel.Type != null) {
      url += taskPageModel.Type;
    }
    url += '&searchInput=';
    if (taskPageModel.SearchInput != null) {
      url += taskPageModel.SearchInput;
    }
    url += '&filterType=';
    if (taskPageModel.FilterType != null) {
      url += taskPageModel.FilterType;
    }

    url += '&fromDate=';
    if (taskPageModel.FromDate != null) {
      url += taskPageModel.FromDate;
    }
    url += '&toDate=';
    if (taskPageModel.ToDate != null) {
      url += taskPageModel.ToDate;
    }

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as TaskPageModel);
  }

  getEmployeeTasks(employeeNo: string): Observable<Task[]> {
    let url: string = this.apiUrl + 'api/Tasks/GetPlannedEmpTasks/' + employeeNo;

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as Task[]);
  }

  CheckForConstraint(taskGuid: string): Observable<boolean> {
    let url = this.apiUrl + 'api/TimePlan/CheckForConstraint/' + taskGuid;

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as boolean);
  }

  putTaskInfo(updatedTask: Task, company: string = null): Observable<any> {
    let url: string = this.apiUrl + 'api/Tasks/Update';

    return this.http
      .put(url, JSON.stringify(updatedTask), this.getHeaders(company))
      .map(response => response.json() as any);
  }

  putTaskTime(updatedTask: Task, company: string = null): Observable<any> {
    let url: string = this.apiUrl + 'api/Tasks/UpdateTime';

    return this.http
      .put(url, JSON.stringify(updatedTask), this.getHeaders(company))
      .map(response => response.json() as any);
  }

  getTask(TaskGUID: string, company: string = null): Observable<Task> {
    let url: string = this.apiUrl + 'api/Tasks/' + TaskGUID;

    return this.requestInterceptor
      .get(url, this.getHeaders(company))
      .map(response => response.json() as Task);
  }

  getTasksFromJob(jobNo: string): Observable<Task[]> {
    let url: string = this.apiUrl + 'api/Tasks/GetTasksFromJob/' + jobNo;

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as Task[]);
  }

  postTaskInfo(newTask: Task): Observable<any> {
    let url: string = this.apiUrl + 'api/Tasks/Create';

    return this.http
      .post(url, JSON.stringify(newTask), this.getHeaders());
  }

  getPaginatedTasks(searchWords: string, customerNo: string, responsibleNo: string): Observable<Task[]> {
    let url = this.apiUrl + 'api/Tasks/GetPaginatedTasks?seachWords=' + searchWords + '&customerNo=' + customerNo + '&responsibleNo=' + responsibleNo;

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as Task[]);
  }

  getMaintenanceTasks(filterModel: FilterModel): Observable<Task[]> {
    let url: string = this.apiUrl + 'api/Tasks/GetMaintenanceTasks?';

    url += 'fromDate=';
    if (filterModel.FromDate != null) {
      url += filterModel.FromDate;
    }
    url += '&toDate=';
    if (filterModel.ToDate != null) {
      url += filterModel.ToDate;
    }

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as any[]);
  }

}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/task.service.ts